import type { FC } from "react";
import { Card } from "@tennr/frontend/components/Card";
import "./ShadowInfoCard.css";

interface ShadowInfoCardProps {
  image?: string;
  imageAlt?: string;
  body?: string;
  variant?: "dark" | "light";
}

export const ShadowInfoCard: FC<ShadowInfoCardProps> = ({ image, imageAlt, body, variant }) => {
  return (
    <Card className="shadow-info-card" variant={variant}>
      <img className="logo" alt={imageAlt} src={image} draggable={false} />
      <p className="shadow-info-body">{body}</p>
    </Card>
  );
};